export default __webpack_public_path__ + "static/media/calendar-prev.a81de2e0.svg";